const supportsStyleQueries =
  getComputedStyle(document.body).getPropertyValue('--supports-style-queries') === 'true'

if (!supportsStyleQueries) {
  import('./css-theming-implementation.js')
}
